<template>
  <div :id="id" class="cc-product-attributes">
    <h4>
      <span class="text-capitalize"><slot name="attributeName"></slot></span>
      <span class="attribute-error text-danger">
        <slot name="attributeError"></slot>
      </span>
      <template v-if="type === 'addons'"> ({{ count }}/{{ limit }})</template>
    </h4>
    <b-row>
      <slot name="variations"></slot>
    </b-row>
  </div>
</template>

<script>
export default {
  props: ['id', 'type', 'limit', 'count']
}
</script>

<style lang="scss" scoped>
.cc-product-attributes {
  h4 {
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    font-size: 14px;
    color: #2F3941;
  }
}
</style>
